($ => {

    "use strict";
    console.log('app.js');

    $(function() {
        if (typeof AOS !== 'undefined') {
            AOS.init({
                once: true
            });
        }
    });

})(jQuery);